/* eslint-disable no-nested-ternary */
import React from 'react';
import 'moment/min/locales';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import styles from '../../styles/general.module.scss';
import { renderInfoForType } from '../../utils/helpers';
import sortIcon from '../../icons/inspection-icons/sort.svg';
import sortActiveIcon from '../../icons/inspection-icons/sort-active.svg';

const Table = (props) => {
  const { tableHeadders, logs, route, driverpermit, avp, enable_initial_review, settings, forViolations, setSortKey, sortKey } = props;
  const getStatus = (ele) => {
    if (ele === 2 && enable_initial_review) {
        return <div style={{ background: 'rgb(218 234 248)', color: '#3c62a8' }} className={styles.badge}>Pending Review</div>;
    }
    if (ele === 6) {
        return <div style={{ background: '#F7B5001A', color: '#F7B500' }} className={styles.badge}>Pending Approval</div>;
    }
    if (ele === 7) {
      return <div style={{ background: '#A9A9A9', color: '#FFFFFF' }} className={styles.badge}>Cancelled</div>;
    }
    if (ele === 0) {
      return <div style={{ background: '#F7B5001A', color: '#F7B500' }} className={styles.badge}>Training Pending</div>;
    } if (ele === 1) {
      return <div style={{ background: '#6DD4001C', color: '#6DD400' }} className={styles.badge}>Pending Applicant Details</div>;
    } if (ele === 2) {
      return <div style={{ background: '#F7B5001A', color: '#F7B500' }} className={styles.badge}>Pending Approval</div>;
    } if (ele === 3) {
      return <div style={{ background: '#6DD4001C', color: '#6DD400' }} className={styles.badge}>{settings?.badge_status?.[3] || 'Approved'}</div>;
    } if (ele === 4) {
      return <div style={{ background: 'rgb(255, 213, 204)', color: 'rgb(255, 87, 51 )' }} className={styles.badge}>Rejected</div>;
    } if (ele === 5) {
      return <div style={{ background: '#d0d0d0', color: '#454545' }} className={styles.badge}>Expired</div>;
    } if (ele === 8) {
      return (
          <div style={{ background: '#d0d0d0', color: '#454545' }} className={styles.badge}>
              {settings?.badge_status?.[8] || 'Suspended'}
          </div>
      );
    } if (ele === 9) {
      return (
          <div style={{ background: '#A9A9A9', color: '#FFFFFF' }} className={styles.badge}>
              {settings?.badge_status?.[9] || 'Revoked'}
          </div>
      );
    } if (ele === 10) {
      return <div style={{ background: '#0079C1', color: '#FFFFFF' }} className={styles.badge}>Payment Pending</div>;
    } if (ele === 11) {
      return <div style={{ background: '#F7B5001A', color: '#F7B500' }} className={styles.badge}>Pending Schedule</div>;
    } if (ele === 15) {
      return <div style={{ background: '#F7B5001A', color: '#F7B500' }} className={styles.badge}>Application Withheld</div>;
    } if (ele === 16) {
      return <div style={{ background: '#F7B5001A', color: '#F7B500' }} className={styles.badge}>Reschedule Test</div>;
    } if (ele === 18) {
      return <div style={{ background: '#F7B5001A', color: '#F59E0B' }} className={styles.badge}>Re-Verify Documentation</div>;
    } if (ele === 'open') {
      return <div style={{ background: '#A9A9A9', color: '#FFFFFF' }} className={styles.badge}>Open</div>;
    } if (ele === 'pending_review') {
      return <div style={{ background: 'rgb(218 234 248)', color: '#3c62a8', width: '120%' }} className={styles.badge}>Pending Review</div>;
    } if (ele === 'closed') {
      return (
        <div style={{ background: '#6DD4001C', color: '#6DD400' }} className={styles.badge}>Closed</div>
      );
    } if (ele === 'rejected') {
      return <div style={{ background: 'rgb(255, 213, 204)', color: 'rgb(255, 87, 51 )' }} className={styles.badge}>Rejected</div>;
    }
    if (ele === 14) {
      return <div style={{ background: '#d0d0d0', color: '#454545' }} className={styles.badge}>Draft</div>;
    }
    return null;
  };
  const appealStatus ={ In_review: 'Under Appeal', Approved: 'Appeal Approved', Rejected: 'Appeal Rejected' };
 const handleSortColumn = (field) => {
    if (setSortKey) {
      setSortKey(sortKey === field ? `-${field}` : field);
    }
  };
  const getRoute = (e) => {
    if (e?.rejected_reOpen || e?.rejected_reopen) {
     return `${route}/detail/${e.id}/reapply`;
    }
    if (!(e?.rejected_reOpen && e?.rejected_reopen) && (e?.application_type === 'Renewal' || e?.type_of_issue === 'Renewal')) {
      return `${route}/detail/${e.id}/renewal`;
    }
    return `${route}/draft/application/${e.id}`;
  };

  const getCustomFieldValue = (rawValue, fieldKey) => {
    if (!fieldKey.includes('custom-') && !fieldKey.includes('admin-')) return '';
    if (Array.isArray(rawValue)) {
        return rawValue.join(', ');
    }
    if (typeof rawValue === 'boolean') {
        return rawValue ? 'Yes' : 'No';
    }
    const value = rawValue ?? '';

    const isIsoZ = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z$/.test(value);
    const isIsoOffset = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}([+-]\d{2}:\d{2})$/.test(value);

    if ((isIsoZ || isIsoOffset) && !Number.isNaN(new Date(value).getTime())) {
        return renderInfoForType({ type: 'date' }, value, null, null);
    }
    if (typeof value === 'object' && value !== null) {
        return Object.values(value).join(', ');
    }
    return value;
  };

  const dateFields = ['approved_on', 'created_at', 'suspended_at', 'updated_at', 'violation_at',
    'reversed_at', 'valid_until', 'defect_at', 'dob', 'lic_exp_date', 'lic_issue_date', 'payment_date',
    'renewal_date', 'insurance_validity', 'pc_validity', 'training_completed_at', 'avp_validity'];

  return <>{logs?.length === 0 ? <p className={styles.emptyLog}>There are no applications to display</p> : (
    <table className={`${styles.table}`} style={{ margin: 'auto', marginTop: 0, width: driverpermit || avp ? '80%' : '100%' }}>
      <thead>
        <tr>
          {tableHeadders?.map(ele => (
            <th style={{ textOverflow: 'unset', textWrap: 'wrap', lineHeight: '2', padding: '15px 24px' }}>
              <FormattedMessage id="module.id" defaultMessage={ele[1]} />
              {/* Only show sort icon for specific columns when sortKey is set */}
              {['renewal_date', 'lic_exp_date', 'avp_validity', 'reg_no_veh_eqpt'].includes(ele[0]) && (
                <button
                  type="button"
                  aria-label={`Sort by ${ele[1]}`}
                  style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
                  onClick={() => handleSortColumn(ele[0])}
                >
                  <img
                    src={sortKey === ele[0] ? sortActiveIcon : sortIcon}
                    alt="sortIcon"
                  />
                </button>
              )}
            </th>
          ))}
          <th />
        </tr>
      </thead>
      <tbody>
        {
          logs?.map(e => (
            <tr>
            {tableHeadders.map((ele) => {
              if (['custom-', 'admin-'].includes(ele[0])) {
                return (
                  <td>
                    {getCustomFieldValue(ele[0].includes('admin-')
                    ? e.admin_response?.[ele[0]] : e.response?.[ele[0]], ele[0])}
                  </td>
                );
              }
              if (ele[0] === 'status') {
                return <td>{getStatus(e[ele[0]])}</td>;
              }
              if (ele[0] === 'violation_type') {
                  if (e?.violation_type) {
                      return <td>{e?.violation_type}</td>;
                  }
                  if (e.permit_management_vehiclepermit?.avp_no) {
                      return <td>{'Vehicle'}</td>;
                  }
                  return <td>{'Driver'}</td>;
              }
              if (ele[0] === 'badge_no') {
                  if (e.permit_management_vehiclepermit?.avp_no) {
                      return <td>{e.permit_management_vehiclepermit.avp_no}</td>;
                  } if (e.permit_management_driverpermit?.badge_no) {
                    return <td>{e.permit_management_driverpermit.badge_no}</td>;
                }
                  return <td>{e[ele[0]]}</td>;
              }
              if (ele[0] === 'first_name') {
                if (e.permit_management_driverpermit?.first_name) {
                    return <td>{e.permit_management_driverpermit.first_name}</td>;
                }
                  return <td>{e[ele[0]]}</td>;
              }
              if (ele[0] === 'last_name') {
                  if (e.permit_management_driverpermit?.last_name) {
                    return <td>{e.permit_management_driverpermit.last_name}</td>;
                }
                  return <td>{e[ele[0]]}</td>;
              }
              if (ele[0] === 'activated_by') {
                return <td>{e.re_activated_by}</td>;
              }
                return (
                  dateFields.includes(ele[0])
                    ? <td> {renderInfoForType({ 'type': 'date' }, e[ele[0]], null, null)} </td>
                    : <td> {e[ele[0]] || e.response?.[ele[0]] || ''} </td>
                );
              })}
              <td>
                {e.status === 14
                ? (
                  <Link
                  to={{
                    pathname: getRoute(e),
                    state: { isAdminForm: settings?.allow_admin_to_submit_driver_application }
                  }}
                  >
                    {(forViolations && e.permit_management_violationappeal.length>0)
                    ? <FormattedMessage id=" " defaultMessage={appealStatus[e.permit_management_violationappeal[0].status]} />
                    : <FormattedMessage
                    id="inspections.list.table.view"
                    defaultMessage="View"
                  />}
                  </Link>
                ) : (
                  <Link to={`${route}/detail/${e.id}`}>
                    {(forViolations && e.permit_management_violationappeal.length>0)
                    ? <FormattedMessage id=" " defaultMessage={appealStatus[e.permit_management_violationappeal[0].status]} />
                    : <FormattedMessage
                    id="inspections.list.table.view"
                    defaultMessage="View"
                  />}
                  </Link>
                )}
              </td>
            </tr>
          ))}
      </tbody>
    </table>)
  }
         </>;
};

export default Table;
